import React from 'react'

function ProjectRisk() {
  return (
    <div className="w-full  bg-white py-5">
    <div className="max-w-6xl mx-24 px-4">
      <div className="flex flex-col md:flex-row items-start">
        <div className="md:w-1/3 flex justify-center mb-6 md:mb-0">
          <img
            src="/assets/project_risk_managment.png"
            alt="PROJECT CONTROL"
            className="w-full h-auto max-h-64 object-cover"
          />
        </div>

        <div className="md:w-2/3 text-left md:pl-8">
          <h2 className="text-2xl font-bold mb-4">
            PROJECT RISK MANAGEMENT
          </h2>
          <p className="mb-4">
            In today's ever-evolving project landscapes, effective risk
            management is of paramount importance. Project managers operate
            in dynamic environments where risks—factors that could
            potentially impact a project's timeline, performance, or
            budget—abound.{" "}
          </p>
          <p className="mb-4">
            Implementing robust Project Risk Management procedures,
            encompassing identification, analysis, and responsive actions
            throughout a project's lifecycle, greatly empowers project teams
            to successfully achieve their objectives within established time
            and budget constraints.{" "}
          </p>
          <p className="mb-4">
            Risk management entails the proactive anticipation of potential
            disruptions and the strategic deployment of measures to mitigate
            uncertainty to an acceptable level. It's a process that
            acknowledges the fluidity of project work, continually capturing
            and addressing emerging risks and integrating newfound knowledge
            into existing risk analyses.
          </p>
          <p className="mb-4">
            At The Six Consultancy, we specialize in Project Risk
            Management, offering services that encompass the establishment
            of tailored risk management procedures, the development of
            customized templates and formats, the generation of periodic
            risk assessment reports, and the provision of recommendations to
            mitigate risk scores, among other invaluable contributions."
          </p>
          <p className="mb-4">
            This revised text maintains the essence of the original while
            enhancing clarity and readability.
          </p>
        </div>
      </div>
    </div>
  </div>  )
}

export default ProjectRisk